/* src/interviews/reducers.js */

import { combineReducers } from 'redux';
import { keyBy, omit } from 'lodash';

import {
  // addScheduleTypes,
  fetchScheduleTypes,
  fetchInterviewLocationsTypes,
  fetchInterviewsTypes,
  confirmInterviewTypes,
  declineInterviewTypes,
  fetchApplicantTypes,
  fetchInterviewQuestionsTypes,
  addInterviewQuestionTypes,
  updateInterviewQuestionTypes,
  removeInterviewQuestionTypes,
  saveAnswersAndRatingsTypes,
  updateApplicantStatusTypes,
  CLEAR_APPLICANT_FIELDS,
} from './action_types';

import { makeRequestReducer } from '../../config/client';

const normalize = (state, res) => keyBy(res, '_id');
const update = (state, res) => ({ ...state.data, [res._id]: res });
const remove = (state, res) => omit(state.data, res);

const interviews = makeRequestReducer({
  types: fetchInterviewsTypes,
  name: 'interviews',
  mutate: normalize,
  append: [
    makeRequestReducer({
      types: confirmInterviewTypes,
      name: 'confirmInterview',
      mutate: update,
    }),
    makeRequestReducer({
      types: declineInterviewTypes,
      name: 'declineInterview',
      mutate: update,
    }),
  ],
});

// TODO: might have to normalize later when we add edit/remove availabilities
const schedule = makeRequestReducer({
  types: fetchScheduleTypes,
  name: 'adminSchedules',
});

const locations = makeRequestReducer({
  types: fetchInterviewLocationsTypes,
  name: 'fetchInterviewLocations',
  mutate: normalize,
});

const initialApplicantState = {
  _id: '',
  bio: 'no bio',
  user: {
    first: 'first',
    last: 'last',
    email: 'email',
    phone: 'phone',
    avatar: '',
    education: [],
  },
  applicant: [{
    ratings: {
      knowledge: 1,
      organization: 1,
      helpfulness: 1,
    },
    qAndA: [],
    status: 'PENDING',
  }],
};

const applicant = makeRequestReducer({
  types: fetchApplicantTypes,
  name: 'tutorByID',
  initialData: initialApplicantState,
  append: [
    makeRequestReducer({
      types: saveAnswersAndRatingsTypes,
      name: 'updateQuestionsAndRatings',
      mutate: (state, res) => ({ ...state.data, applicant: res }),
    }),
    makeRequestReducer({
      types: updateApplicantStatusTypes,
      name: 'updateApplicantStatus',
      mutate: (state, res) => ({ ...state.data, applicant: res }),
    }),
    (state, action) => {
      if (action.type === CLEAR_APPLICANT_FIELDS)
        return { ...state, data: initialApplicantState };
      return state;
    },
  ],
});

const questions = makeRequestReducer({
  types: fetchInterviewQuestionsTypes,
  name: 'questions',
  mutate: normalize,
  append: [
    makeRequestReducer({
      types: addInterviewQuestionTypes,
      name: 'addQuestion',
      mutate: update,
    }),
    makeRequestReducer({
      types: updateInterviewQuestionTypes,
      name: 'updateQuestion',
      mutate: update,
    }),
    makeRequestReducer({
      types: removeInterviewQuestionTypes,
      name: 'removeQuestion',
      mutate: remove,
    }),
  ],
});

export default combineReducers({
  interviews,
  schedule,
  locations,
  applicant,
  questions,
});



// WEBPACK FOOTER //
// ./src/modules/interviews/reducers.js